import { render, staticRenderFns } from "./PlaneChangeCard.vue?vue&type=template&id=0b3459ca&scoped=true"
import script from "./PlaneChangeCard.vue?vue&type=script&lang=js"
export * from "./PlaneChangeCard.vue?vue&type=script&lang=js"
import style0 from "./PlaneChangeCard.vue?vue&type=style&index=0&id=0b3459ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3459ca",
  null
  
)

export default component.exports